import { concat, from, of } from "rxjs";
import { actionModalCloseAll, actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionTutorialSelect } from "../../actionTutorial";
import { IdTutorialStep } from "../../IdTutorialStep";
export var pathOpenQuestMenu = function (action, state$, deps) {
    var openBuildMenu$ = from([actionModalCloseAll(), actionModalOpen(IdModal.Quests)]);
    var selectTutorialStep$ = of(actionTutorialSelect(IdTutorialStep.checkNewQuest_clickQuestMenu));
    if (action.tutorialStep === IdTutorialStep.collectQuestReward_clickCollectRewards) {
        selectTutorialStep$ = of(actionTutorialSelect(IdTutorialStep.collectQuestReward_clickQuestMenu));
    }
    return concat(selectTutorialStep$, openBuildMenu$);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/path/pathOpenQuestMenu.ts
// module id = 2474
// module chunks = 3